export enum AddNewMedicineFieldLabel {
  IntakeRegime = "Režim doziranja",
  IntakePartOfDay = "Doba dana uzimanja",
  Inn = "INN",
  Type = "Vrsta",
  Name = "Naziv lijeka / dodatka prehrani",
}
